(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var inputFocusEffect = function inputFocusEffect() {
  var inputs = document.querySelectorAll('[data-input-icon="input"]');
  if (inputs.length) {
    var handleFocusInput = function handleFocusInput(_ref) {
      var target = _ref.target;
      var inputTarget = target;
      var boxInput = inputTarget.parentElement;
      boxInput.classList.add("active");
    };
    var handleBlurInput = function handleBlurInput(_ref2) {
      var target = _ref2.target;
      var inputTarget = target;
      var boxInput = inputTarget.parentElement;
      boxInput.classList.remove("active");
    };
    inputs.forEach(function (input) {
      input.addEventListener("focus", handleFocusInput);
      input.addEventListener("blur", handleBlurInput);
    });
  }
};
var _default = exports["default"] = inputFocusEffect;

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var knowledgeBaseItem = function knowledgeBaseItem() {
  var knowledgeBaseBtns = document.querySelectorAll('[data-knowledge-base="btn"]');
  var knowledgeBaseItens = document.querySelectorAll('[data-knowledge-base="item"]');
  if (knowledgeBaseBtns.length && knowledgeBaseItens.length) {
    var handleClick = function handleClick(btnTarget, indexTarget) {
      var knowledgeBaseBtnTarget = knowledgeBaseBtns[indexTarget];
      var knowledgeBaseItemTarget = knowledgeBaseItens[indexTarget];
      knowledgeBaseBtns[indexTarget].classList.toggle('active');
      knowledgeBaseItens[indexTarget].classList.toggle('active');
      var isBtnTargetActive = knowledgeBaseBtnTarget.classList.contains('active');
      var knowledgeBaseBtnTargetText = knowledgeBaseBtns[indexTarget].querySelector('[data-knowledge-base="btn-text"]');
      if (isBtnTargetActive) {
        knowledgeBaseBtnTargetText.innerText = 'Recolher';
      } else {
        knowledgeBaseBtnTargetText.innerText = 'Ver detalhes';
      }
    };
    knowledgeBaseBtns.forEach(function (btn, index) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        handleClick(btn, index);
      });
    });
  }
};
var _default = exports["default"] = knowledgeBaseItem;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var modal = function modal() {
  var modals = document.querySelectorAll("[data-modal]");
  var modalAlertBtnsOpen = document.querySelectorAll('[data-modal-action="open"]');
  var modalAlertBtnsClose = document.querySelectorAll('[data-modal-action="close"]');
  if (!modalAlertBtnsOpen.length && !modalAlertBtnsClose.length) return;
  function openModal(event) {
    event.preventDefault();
    var modalName = this.dataset.modalName;
    var modalTarget = document.querySelector("[data-modal=".concat(modalName, "]"));
    modalTarget.classList.toggle("active");
  }
  function closeModal(event) {
    event.preventDefault();
    var modalName = this.dataset.modalName;
    var modalTarget = document.querySelector("[data-modal=".concat(modalName, "]"));
    modalTarget.classList.toggle("active");
  }
  function clickOutsideModal(event) {
    var isContainer = event.target === this;
    if (isContainer) {
      this.classList.remove("active");
    }
  }
  modalAlertBtnsOpen.forEach(function (btnOpen) {
    btnOpen.addEventListener("click", openModal);
  });
  modalAlertBtnsClose.forEach(function (btnClose) {
    btnClose.addEventListener("click", closeModal);
  });
  modals.forEach(function (modal) {
    modal.addEventListener("click", clickOutsideModal);
  });
};
var _default = exports["default"] = modal;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var sidebar = function sidebar() {
  var sidebar = document.querySelector('[data-sidebar="box"]');
  if (sidebar) {
    var toggleSidebar = function toggleSidebar() {
      sidebar.classList.toggle("active");
      sidebarContainer.classList.toggle("active");
    };
    var sidebarContainer = document.querySelector('[data-sidebar="overlay"]');
    var sidebarBtns = document.querySelectorAll('[data-sidebar="btn"]');
    sidebarBtns.forEach(function (btn) {
      btn.addEventListener("click", toggleSidebar);
    });
    sidebarContainer.addEventListener("click", toggleSidebar);
  }
};
var _default = exports["default"] = sidebar;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkDropdown = linkDropdown;
var _outsideClick = _interopRequireDefault(require("./outsideClick.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function linkDropdown() {
  var links = $('[data-link-dropdown="btn"]');
  if (links.length) {
    var showDropdown = function showDropdown(targetElement) {
      console.log("--- targetElement", targetElement);
      targetElement.addClass("active");
      targetElement.children('[data-link-dropdown="list"]').addClass("active");
      activeSidebar(targetElement);
    };
    var hideDropdown = function hideDropdown(targetElement) {
      targetElement.removeClass("active");
      targetElement.children('[data-link-dropdown="list"]').removeClass("active");
    };
    var handleClickLink = function handleClickLink(event) {
      var targetElement = $(this);
      console.log(targetElement);
      if (!$(this).hasClass("active")) {
        showDropdown(targetElement);
        (0, _outsideClick["default"])({
          element: targetElement.children('[data-link-dropdown="list"]')[0],
          events: ["click"],
          callback: function callback() {
            return hideDropdown(targetElement);
          }
        });
      }
    };
    var activeSidebar = function activeSidebar(targetElement) {
      var sidebar = targetElement.closest('[data-sidebar="box"]');
      var sidebarContainer = $('[data-sidebar="overlay"]');
      if (!sidebar.hasClass("active") && sidebar.length) {
        sidebar.addClass("active");
        sidebarContainer.addClass("active");
      }
    };
    links.on("click", handleClickLink);
  }
}

},{"./outsideClick.js":8}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loaderPageChangeMessage = loaderPageChangeMessage;
function loaderPageChangeMessage() {
  var loaderPage = document.querySelector("[data-loader-page]");
  if (loaderPage) {
    var getRandomMessage = function getRandomMessage() {
      var randomIndex = Math.floor(Math.random() * messages.length);
      return messages[randomIndex];
    };
    var handleMutation = function handleMutation(mutation) {
      if (mutation[0].target.classList.contains("loading")) {
        loaderPageText.innerText = getRandomMessage();
      }
    };
    var loaderPageText = document.querySelector("[data-loader-page] .loader-box-text");
    var messages = ["Aguarde e faça uma oração igual Jesus! 🙏", "Cante um louvor enquanto carrega a página 🎤", "Enquanto espera, que tal um sorriso? 😁"];
    var observer = new MutationObserver(handleMutation);
    observer.observe(loaderPage, {
      attributes: true
    });
  }
}

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loaderPageRemoveOnLoadPage = loaderPageRemoveOnLoadPage;
function loaderPageRemoveOnLoadPage() {
  var hasTableOnPageTarget = $(".box-table-container");
  var loaderPage = $("[data-loader-page]");
  if (loaderPage.length && !hasTableOnPageTarget.length) {
    setTimeout(function () {
      loaderPage.removeClass("active");
    }, 500);
  }
}

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = outsideClick;
function outsideClick(_ref) {
  var element = _ref.element,
    events = _ref.events,
    callback = _ref.callback;
  var html = document.documentElement;
  var outside = "data-outside";
  console.log("-- element", element);
  if (!element.hasAttribute(outside)) {
    events.forEach(function (userEvent) {
      setTimeout(function () {
        html.addEventListener(userEvent, handleOutsideClick);
      });
    });
    element.setAttribute(outside, "");
  }
  function handleOutsideClick(event) {
    if (!element.contains(event.target)) {
      element.removeAttribute(outside);
      events.forEach(function (userEvent) {
        html.removeEventListener(userEvent, handleOutsideClick);
      });
      callback();
    }
  }
}

},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userDetails = userDetails;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function userDetails(_ref) {
  var endpoint = _ref.endpoint;
  var usersBtnsDetails = $('[data-table-actions="details"]');
  if (usersBtnsDetails.length) {
    usersBtnsDetails.on("click", function () {
      var id = $(this).data("id");
      var idModal = $('[data-modal="details"]').data("modal-id");
      var modalDetailsLoader = $('[data-modal="details"] .loader-box');
      if (id === idModal) {
        modalDetailsLoader.removeClass("active");
        return;
      }
      $.ajax({
        url: "".concat(endpoint, "/").concat(id),
        type: "GET",
        beforeSend: function beforeSend() {
          modalDetailsLoader.addClass("active");
        },
        success: function success(_ref2) {
          var data = _ref2.data,
            status = _ref2.status,
            userType = _ref2.userType;
          var modalDetailsList = $('[data-modal-details="list"]');
          console.log(data);
          if (status === "success" && userType === "membros") {
            var dataObj = {
              Nome: data.nome,
              Telefone: data.sobrenome,
              "Data de nascimento": data.dataNascimento,
              endereço: data.endereco,
              "Batizado na igreja EVANGÉLICA?": data.batizado,
              "Oração por algo específico?": data.pedidoOracao
            };
            Object.entries(dataObj).forEach(function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 2),
                key = _ref4[0],
                value = _ref4[1];
              var li = document.createElement("li");
              if (value) {
                li.textContent = "".concat(key, ": ").concat(value);
                ul.appendChild(li); // Adiciona o <li> na <ul>
              }
            });
          }
          setTimeout(function () {
            modalDetailsLoader.removeClass("active");
          }, 500);
          if (status === "error") {}
        },
        error: function error(xhr, status, _error) {
          console.error("Erro ao alterar o status:", _error);
        },
        complete: function complete() {}
      });
    });
  }
}

},{}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.congregatedTable = congregatedTable;
var _userDetails = require("../../global/userDetails.js");
function congregatedTable() {
  var congregatedDataTable = $('[data-table="congregated"]');
  if (congregatedDataTable.length) {
    var loaderPage = $("[data-loader-page]");
    loaderPage.addClass("loading");
    congregatedDataTable.DataTable({
      scrollX: true,
      language: {
        url: "/theme/src/assets/datatable/pt_br.json",
        search: ""
      },
      dom: '<"box-top-right"lfB>rtip',
      lengthMenu: [5, 10, 25, 50, 100],
      pageLength: 10,
      ajax: {
        url: "".concat(baseURL, "api/usuarios/lista/congregados"),
        type: "GET",
        dataSrc: "data"
      },
      processing: true,
      order: [[0, "desc"]],
      columns: [{
        data: "id_usuario"
      }, {
        data: "nome"
      }, {
        data: "telefone"
      }, {
        data: null,
        render: function render(data, type, row) {
          if (data.e_whatsapp == 1) {
            return "Sim";
          } else {
            return "Não";
          }
        }
      }, {
        data: null,
        render: function render(data, type, row) {
          if (data.batizado == 1) {
            return "Sim";
          } else {
            return "Não";
          }
        }
      }, {
        data: "sexo"
      }, {
        data: "data_criado"
      }, {
        data: null,
        // class: "text-left table-name",
        render: function render(data, type, row) {
          // <div class="members-item-action">
          //     <a href="${baseURL}#">
          //       Transformar novo membro
          //       <img src="/theme/src/img/icon/member-item-user.svg" alt="" />
          //     </a>
          //   </div>
          //    <div class="members-item-action">
          //    <a href="#" data-modal="open" data-modal-name="details">
          //      Ver detalhes
          //      <img src="/theme/src/img/icon/member-item-details.svg" alt="" />
          //    </a>
          //  </div>
          //                <div class="members-item-action">
          //     <a href="#" data-modal="open" data-modal-name="facilitator">
          //       Facilitador
          //     </a>
          //   </div>
          return "\n            <div class=\"members-right flex\">\n              <div class=\"members-item-action\">\n                <a href=\"".concat(baseURL, "cadastro/congregados/editar/").concat(data.id_encrypt, "\">\n                  Editar\n                  <img src=\"/theme/src/img/icon/member-item-edit.svg\" alt=\"\" />\n                </a>\n              </div>\n            </div>");
        }
      }],
      columnDefs: [
        // {
        //   targets: 5,
        //   visible: false,
        // },
      ],
      initComplete: function initComplete() {
        (0, _userDetails.userDetails)({
          endpoint: "".concat(baseURL, "ajax/congregados")
        });
        $('input[type="search"]').attr("placeholder", "Ex: João");
        $(".home .box-top .right").append($(".dataTables_length"));
        $(".home .box-top .right").append($(".dataTables_filter"));
        $("div.dt-search").append('<img src="/theme/src/img/icon/search.svg" alt="ícone de uma lupa">');
        var btnModalNewConvert = $('[data-modal="open"][data-modal-name="details"]');
        var modalNewConvert = $('[data-modal="details"]');
        btnModalNewConvert.on("click", function () {
          modalNewConvert.addClass("active");
        });
      },
      drawCallback: function drawCallback() {
        setTimeout(function () {
          loaderPage.removeClass("loading");
          loaderPage.removeClass("active");
        }, 500);
      }
    });
  }
}

},{"../../global/userDetails.js":9}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coursesClassSummaryOptions = coursesClassSummaryOptions;
function coursesClassSummaryOptions() {
  var options = document.querySelectorAll('[data-courses-class-summary="option"]');
  if (options.length) {
    var handleClickSummaryOption = function handleClickSummaryOption(event) {
      event.preventDefault();
      if (this.classList.contains("active")) return;
      options.forEach(function (option) {
        return option.classList.remove("active");
      });
      this.classList.add("active");
    };
    options.forEach(function (option) {
      option.addEventListener("click", handleClickSummaryOption);
    });
  }
}

},{}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coursesClassTabnav = coursesClassTabnav;
function coursesClassTabnav() {
  var btns = document.querySelectorAll('[data-courses-class-option="btn"]');
  var contents = document.querySelectorAll('[data-courses-class-option="content"]');
  if (btns.length && contents.length) {
    var handleClickOptionBtn = function handleClickOptionBtn(indexTarget) {
      btns.forEach(function (btn) {
        return btn.parentElement.classList.remove("active");
      });
      contents.forEach(function (btn) {
        return btn.classList.remove("active");
      });
      btns[indexTarget].parentElement.classList.add("active");
      contents[indexTarget].classList.add("active");
    };
    btns.forEach(function (btn, index) {
      btn.addEventListener("click", function (event) {
        event.preventDefault();
        handleClickOptionBtn(index);
      });
    });
  }
}

},{}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eventsTable = eventsTable;
var _userDetails = require("../../global/userDetails.js");
function eventsTable() {
  var eventsDataTable = $('[data-table="events"]');
  if (eventsDataTable.length) {
    // Verificar se baseURL está definida
    if (typeof baseURL === 'undefined') {
      console.error('baseURL não está definida');
      return;
    }
    var loaderPage = $("[data-loader-page]");
    loaderPage.addClass("loading");
    eventsDataTable.DataTable({
      scrollX: true,
      scrollCollapse: true,
      autoWidth: false,
      language: {
        url: "/theme/src/assets/datatable/pt_br.json",
        search: ""
      },
      dom: '<"box-top-right"lfB>rtip',
      lengthMenu: [5, 10, 25, 50, 100],
      pageLength: 10,
      ajax: {
        url: "".concat(baseURL, "api/eventos/lista"),
        type: "GET",
        dataSrc: "data",
        error: function error(xhr, _error, thrown) {
          console.error('Erro na requisição AJAX:', _error);
          console.error('Detalhes:', thrown);
        }
      },
      processing: true,
      serverSide: false,
      order: [[0, "desc"]],
      columns: [{
        data: null,
        title: "Evento",
        render: function render(data, type, row) {
          return "<span data-checkout-events=\"title-text\">".concat(data.id_evento, " - ").concat(data.nome, "</span>");
        }
      }, {
        data: "data_evento_formatada",
        title: "Data"
      }, {
        data: null,
        title: "Vagas",
        render: function render(data, type, row) {
          return "".concat(data.vagas_disponiveis, " / ").concat(data.vagas_reservadas, " / ").concat(data.vagas_confirmadas);
        }
      }, {
        data: "preco",
        title: "Preço"
      }, {
        data: "saldo_disponivel",
        title: "Saldo",
        render: function render(data, type, row) {
          return "<span data-checkout-events=\"saldo-text\">R$ ".concat(parseFloat(data || 0).toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }), "</span>");
        }
      }, {
        data: "status",
        title: "Status"
      }, {
        data: null,
        title: "Link",
        render: function render(data, type, row) {
          return "<a href=\"".concat(data.link_checkout, "\" target=\"_blank\">\n              <span data-checkout-events=\"link-text\">").concat(data.link_checkout, "</span>\n            </a>");
        }
      }, {
        data: null,
        title: "Ações",
        orderable: false,
        searchable: false,
        render: function render(data, type, row) {
          var saldo = parseFloat(data.saldo_disponivel || 0);
          var podeSacar = saldo >= 500;
          return "\n              <div class=\"actions table-actions-item\">\n                <a href=\"".concat(baseURL, "cadastro/eventos/visualizar/").concat(data.id_encrypt, "\" class=\"btn-action\" title=\"Ver detalhes\">\n                  <img src=\"/theme/src/img/icon/member-item-details.svg\" alt=\"Ver detalhes\">\n                </a>\n                <a href=\"").concat(baseURL, "cadastro/eventos/editar/").concat(data.id_encrypt, "\" class=\"btn-action\" title=\"Editar\">\n                  <img src=\"/theme/src/img/icon/member-item-edit.svg\" alt=\"Editar\">\n                </a>\n                ").concat(podeSacar ? "\n                  <button onclick=\"abrirModalSaque(".concat(data.id_evento, ")\" class=\"btn-action\" title=\"Solicitar Saque\" style=\"background: #28a745; color: white; border: none; padding: 8px 12px; border-radius: 4px; cursor: pointer;\">\n                    \uD83D\uDCB0\n                  </button>\n                ") : "", "\n              </div>\n            ");
        }
      }],
      columnDefs: [
        // {
        //   targets: 7, // Coluna de ações
        //   width: "120px",
        //   className: "text-center"
        // },
        // {
        //   targets: [0, 1, 2, 3, 4, 5, 6], // Todas as outras colunas
        //   className: "text-left"
        // }
      ],
      initComplete: function initComplete() {
        (0, _userDetails.userDetails)({
          endpoint: "".concat(baseURL, "ajax/eventos")
        });
        $('input[type="search"]').attr("placeholder", "Ex: João");
        $(".home .box-top .right").append($(".dataTables_length"));
        $(".home .box-top .right").append($(".dataTables_filter"));
        $("div.dt-search").append('<img src="/theme/src/img/icon/search.svg" alt="ícone de uma lupa">');
        var btnModalNewConvert = $('[data-modal="open"][data-modal-name="details"]');
        var modalNewConvert = $('[data-modal="details"]');
        btnModalNewConvert.on("click", function () {
          modalNewConvert.addClass("active");
        });
      },
      drawCallback: function drawCallback(settings) {
        try {
          setTimeout(function () {
            loaderPage.removeClass("loading");
            loaderPage.removeClass("active");
          }, 500);
        } catch (error) {
          console.error('Erro no drawCallback:', error);
          loaderPage.removeClass("loading");
          loaderPage.removeClass("active");
        }
      },
      error: function error(xhr, _error2, thrown) {
        console.error('Erro no DataTable:', _error2);
        console.error('Detalhes:', thrown);
        loaderPage.removeClass("loading");
        loaderPage.removeClass("active");
      }
    });
  }
}

},{"../../global/userDetails.js":9}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.membersTable = membersTable;
var _userDetails = require("../../global/userDetails.js");
function membersTable() {
  var membersDataTable = $('[data-table="members"]');
  if (membersDataTable.length) {
    var loaderPage = $("[data-loader-page]");
    loaderPage.addClass("loading");
    membersDataTable.DataTable({
      scrollX: true,
      language: {
        url: "/theme/src/assets/datatable/pt_br.json",
        search: ""
      },
      dom: '<"box-top-right"lfB>rtip',
      lengthMenu: [5, 10, 25, 50, 100],
      pageLength: 10,
      ajax: {
        url: "".concat(baseURL, "api/usuarios/lista"),
        type: "GET",
        dataSrc: "data"
      },
      processing: true,
      order: [[0, "desc"]],
      columns: [{
        data: "id_usuario"
      }, {
        data: "nome"
      }, {
        data: "telefone"
      }, {
        data: null,
        render: function render(data, type, row) {
          if (data.e_whatsapp == 1) {
            return "Sim";
          } else {
            return "Não";
          }
        }
      }, {
        data: null,
        render: function render(data, type, row) {
          if (data.batizado == 1) {
            return "Sim";
          } else {
            return "Não";
          }
        }
      }, {
        data: "sexo"
      }, {
        data: "data_criado"
      }, {
        data: null,
        // class: "text-left table-name",
        render: function render(data, type, row) {
          // <div class="members-item-action">
          //     <a href="${baseURL}#">
          //       Transformar novo membro
          //       <img src="/theme/src/img/icon/member-item-user.svg" alt="" />
          //     </a>
          //   </div>
          //    <div class="members-item-action">
          //    <a href="#" data-modal="open" data-modal-name="details">
          //      Ver detalhes
          //      <img src="/theme/src/img/icon/member-item-details.svg" alt="" />
          //    </a>
          //  </div>
          //                <div class="members-item-action">
          //     <a href="#" data-modal="open" data-modal-name="facilitator">
          //       Facilitador
          //     </a>
          //   </div>
          return "\n            <div class=\"members-right flex\">\n              <div class=\"members-item-action\">\n                <a href=\"".concat(baseURL, "cadastro/membros/editar/").concat(data.id_encrypt, "\">\n                  Editar\n                  <img src=\"/theme/src/img/icon/member-item-edit.svg\" alt=\"\" />\n                </a>\n              </div>\n            </div>");
        }
      }],
      columnDefs: [
        // {
        //   targets: 5,
        //   visible: false,
        // },
      ],
      initComplete: function initComplete() {
        (0, _userDetails.userDetails)({
          endpoint: "".concat(baseURL, "ajax/membros")
        });
        $('input[type="search"]').attr("placeholder", "Ex: João");
        $(".home .box-top .right").append($(".dataTables_length"));
        $(".home .box-top .right").append($(".dataTables_filter"));
        $("div.dt-search").append('<img src="/theme/src/img/icon/search.svg" alt="ícone de uma lupa">');
        var btnModalNewConvert = $('[data-modal="open"][data-modal-name="details"]');
        var modalNewConvert = $('[data-modal="details"]');
        btnModalNewConvert.on("click", function () {
          modalNewConvert.addClass("active");
        });
      },
      drawCallback: function drawCallback() {
        setTimeout(function () {
          loaderPage.removeClass("loading");
          loaderPage.removeClass("active");
        }, 500);
      }
    });
  }
}

},{"../../global/userDetails.js":9}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messageTable = messageTable;
var _userDetails = require("../../global/userDetails.js");
function messageTable() {
  var messageDataTable = $('[data-table="message"]');
  if (messageDataTable.length) {
    var loaderPage = $("[data-loader-page]");
    loaderPage.addClass("loading");
    messageDataTable.DataTable({
      scrollX: true,
      language: {
        url: "/theme/src/assets/datatable/pt_br.json",
        search: ""
      },
      dom: '<"box-top-right"lfB>rtip',
      lengthMenu: [5, 10, 25, 50, 100],
      pageLength: 10,
      ajax: {
        url: "".concat(baseURL, "api/mensagens/lista"),
        type: "GET",
        dataSrc: "data"
      },
      processing: true,
      order: [[2, "desc"]],
      // Ordenar por data de criação (decrescente)
      columns: [{
        data: "titulo",
        title: "Título",
        render: function render(data, type, row) {
          return "<div class=\"table-name\">\n              <span class=\"name\">".concat(data || 'Sem título', "</span>\n            </div>");
        }
      }, {
        data: "tipo_mensagem",
        title: "Tipo",
        render: function render(data, type, row) {
          var tipo = data === 'pontual' ? 'Pontual' : 'Recorrente';
          var badge = data === 'pontual' ? 'badge-success' : 'badge-warning';
          return "<span class=\"badge ".concat(badge, "\">").concat(tipo, "</span>");
        }
      }, {
        data: "ativo",
        title: "Status",
        render: function render(data, type, row) {
          var status = data == 1 ? 'Ativo' : 'Inativo';
          var badge = data == 1 ? 'badge-success' : 'badge-danger';
          return "<span class=\"badge ".concat(badge, "\">").concat(status, "</span>");
        }
      }, {
        data: "data_criado",
        title: "Data Criado",
        render: function render(data, type, row) {
          return data || '-';
        }
      }, {
        data: "nome_criador",
        title: "Criado Por",
        render: function render(data, type, row) {
          return data || '-';
        }
      }, {
        data: null,
        title: "Ações",
        orderable: false,
        searchable: false,
        render: function render(data, type, row) {
          return "\n            <div class=\"message-right flex\">\n              <div class=\"message-item-action\">\n                <a href=\"".concat(baseURL, "mensagens/editar/").concat(row.id_encrypt, "\">\n                  Editar\n                  <img src=\"/theme/src/img/icon/message-item-edit.svg\" alt=\"\" />\n                </a>\n              </div>\n              <div class=\"message-item-action\">\n                <a href=\"").concat(baseURL, "mensagens/detalhes/").concat(row.id_encrypt, "\">\n                  Detalhes\n                  <img src=\"/theme/src/img/icon/message-item-details.svg\" alt=\"\" />\n                </a>\n              </div>\n              <div class=\"message-item-action\">\n                <a href=\"#\" onclick=\"enviarMensagem(").concat(row.id_mensagem, ")\" class=\"btn-enviar\">\n                  Enviar\n                  <img src=\"/theme/src/img/icon/message-item-send.svg\" alt=\"\" />\n                </a>\n              </div>\n            </div>");
        }
      }],
      columnDefs: [{
        targets: [0, 1, 2, 3, 4],
        className: 'text-left'
      }, {
        targets: 5,
        className: 'text-center'
      }],
      initComplete: function initComplete() {
        $('input[type="search"]').attr("placeholder", "Ex: Mensagem de teste");
        $(".home .box-top .right").append($(".dataTables_length"));
        $(".home .box-top .right").append($(".dataTables_filter"));
        $("div.dt-search").append('<img src="/theme/src/img/icon/search.svg" alt="ícone de uma lupa">');
      },
      drawCallback: function drawCallback() {
        setTimeout(function () {
          loaderPage.removeClass("loading");
          loaderPage.removeClass("active");
        }, 500);
      }
    });
  }
}

// Função para enviar mensagem
window.enviarMensagem = function (id_mensagem) {
  if (confirm('Deseja realmente enviar esta mensagem?')) {
    $.ajax({
      url: "".concat(baseURL, "api/mensagens/").concat(id_mensagem, "/enviar"),
      type: 'POST',
      success: function success(response) {
        if (response.status === 'success') {
          alert('Mensagem enviada com sucesso!');
          // Recarregar a tabela
          $('[data-table="message"]').DataTable().ajax.reload();
        } else {
          alert('Erro ao enviar mensagem: ' + response.message);
        }
      },
      error: function error() {
        alert('Erro ao enviar mensagem. Tente novamente.');
      }
    });
  }
};

},{"../../global/userDetails.js":9}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newConvertTable = newConvertTable;
var _userDetails = require("../../global/userDetails.js");
function newConvertTable() {
  var newConvertDataTable = $('[data-table="new-convert"]');
  if (newConvertDataTable.length) {
    var atualizarStatusEfetivo = function atualizarStatusEfetivo() {
      $(".status-contato").off("change").on("change", function () {
        loaderPage.addClass("loading");
        loaderPage.addClass("active");
        var switchElement = $(this);
        var userId = switchElement.data("id"); // Obtém o ID do facilitador
        var status = switchElement.val();
        // let newStatus = switchElement.prop("checked") ? 1 : 0; // Define 1 (SIM) ou 0 (NÃO)

        // Enviar a requisição AJAX para atualizar no banco de dados
        $.ajax({
          url: "".concat(baseURL, "api/novos-convertidos/update/efetivo"),
          // Substitua pela URL real da API
          type: "POST",
          data: {
            id: userId,
            status: status
          },
          success: function success(response) {
            if (response.success) {
              location.reload();
            } else {
              loaderPage.removeClass("loading");
              loaderPage.removeClass("active");
              alert("Erro ao atualizar. Tente novamente.");
              // Reverter o estado caso falhe
              // switchElement.prop("checked", !newStatus);
              // label.text(newStatus === 1 ? "NÃO" : "SIM");
            }
          },
          error: function error() {
            alert("Erro de conexão com o servidor.");
            // Reverter o estado caso falhe
            switchElement.prop("checked", !newStatus);
            label.text(newStatus === 1 ? "NÃO" : "SIM");
          }
        });
      });
    };
    var loaderPage = $("[data-loader-page]");
    loaderPage.addClass("loading");
    newConvertDataTable.DataTable({
      scrollX: true,
      autoWidth: false,
      responsive: false,
      language: {
        url: "/theme/src/assets/datatable/pt_br.json",
        search: ""
      },
      dom: '<"box-top-right"lfB>rtip',
      buttons: [{
        extend: 'copyHtml5',
        text: 'Copiar',
        exportOptions: {
          columns: ':visible'
        }
      }, {
        extend: 'excelHtml5',
        text: 'Excel',
        exportOptions: {
          columns: ':visible'
        }
      }, {
        extend: 'csvHtml5',
        text: 'CSV',
        exportOptions: {
          columns: ':visible'
        }
      }, {
        extend: 'pdfHtml5',
        text: 'PDF',
        exportOptions: {
          columns: ':visible'
        },
        orientation: 'landscape',
        pageSize: 'A4'
      }, {
        extend: 'print',
        text: 'Imprimir',
        exportOptions: {
          columns: ':visible'
        }
      }],
      lengthMenu: [5, 10, 25, 50, 100],
      pageLength: 10,
      ajax: {
        url: "".concat(baseURL, "api/novos-convertidos/lista"),
        type: "GET",
        dataSrc: "data",
        error: function error(xhr, _error, thrown) {
          console.error('Erro ao carregar dados da tabela:', _error);
          console.error('Resposta do servidor:', xhr.responseText);
        }
      },
      processing: true,
      order: [[0, "desc"]],
      columns: [{
        data: "id_novo_convertido"
      }, {
        data: null,
        render: function render(data, type, row) {
          return data.nome + ' ' + data.sobrenome;
        }
      }, {
        data: null,
        render: function render(data, type, row) {
          var texto = ""; // Use `let` em vez de `const` para permitir concatenação

          var icon = "";
          if (data.e_whatsapp == 1) {
            icon = "<a href=\"".concat(data.link_whatsapp, "\" target=\"_blank\">\n                      <svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"20\" height=\"20\" x=\"0\" y=\"0\" viewBox=\"0 0 176 176\" style=\"enable-background:new 0 0 512 512\" xml:space=\"preserve\" class=\"\">\n                          <g><g data-name=\"Layer 2\">\n                              <rect width=\"176\" height=\"176\" fill=\"#29a71a\" rx=\"24\" opacity=\"1\" data-original=\"#29a71a\" class=\"\"></rect>\n                              <g fill=\"#fff\">\n                                  <path d=\"M126.8 49.2a54.57 54.57 0 0 0-87.42 63.13l-5.79 28.11a2.08 2.08 0 0 0 .33 1.63 2.11 2.11 0 0 0 2.24.87l27.55-6.53A54.56 54.56 0 0 0 126.8 49.2zm-8.59 68.56a42.74 42.74 0 0 1-49.22 8l-3.84-1.9-16.89 4 .05-.21 3.5-17-1.88-3.71a42.72 42.72 0 0 1 7.86-49.59 42.73 42.73 0 0 1 60.42 0 2.28 2.28 0 0 0 .22.22 42.72 42.72 0 0 1-.22 60.19z\" fill=\"#ffffff\" opacity=\"1\" data-original=\"#ffffff\" class=\"\"></path>\n                                  <path d=\"M116.71 105.29c-2.07 3.26-5.34 7.25-9.45 8.24-7.2 1.74-18.25.06-32-12.76l-.17-.15C63 89.41 59.86 80.08 60.62 72.68c.42-4.2 3.92-8 6.87-10.48a3.93 3.93 0 0 1 6.15 1.41l4.45 10a3.91 3.91 0 0 1-.49 4l-2.25 2.92a3.87 3.87 0 0 0-.35 4.32c1.26 2.21 4.28 5.46 7.63 8.47 3.76 3.4 7.93 6.51 10.57 7.57a3.82 3.82 0 0 0 4.19-.88l2.61-2.63a4 4 0 0 1 3.9-1l10.57 3a4 4 0 0 1 2.24 5.91z\" fill=\"#ffffff\" opacity=\"1\" data-original=\"#ffffff\" class=\"\"></path>\n                              </g>\n                          </g></g>\n                      </svg>\n                      </a>\n                  ");
          }
          texto += "<span>".concat(data.telefone, " ").concat(icon, "</span>");
          return texto;
        }
      }, {
        data: "endereco_completo",
        render: function render(data, type, row) {
          if (data && data !== '---') {
            // Limitar o tamanho do endereço para não quebrar o layout
            var enderecoTruncado = data.length > 50 ? data.substring(0, 47) + '...' : data;
            return "<span title=\"".concat(data, "\" style=\"cursor: help;\">").concat(enderecoTruncado, "</span>");
          }
          return '---';
        }
      }, {
        data: null,
        render: function render(data, type, row) {
          if (data.batizado == 1) {
            return "Sim<br>";
          } else {
            return "Não<br>" + "(" + data.batizado_descricao + ")";
          }
        }
      }, {
        data: null,
        render: function render(data, type, row) {
          if (data.sexo) {
            return data.sexo + "<br>";
          }
        }
      }, {
        data: null,
        render: function render(data, type, row) {
          if (data.estado_civil) {
            return data.estado_civil + "<br>";
          }
        }
      }, {
        data: null,
        render: function render(data, type, row) {
          return data.data_nascimento;
        }
      }, {
        data: null,
        render: function render(data, type, row) {
          return data.convite;
        }
      }, {
        data: null,
        render: function render(data, type, row) {
          if (data.aceita_msg == 1) {
            return "Aceita receber mensagens<br>";
          } else {
            return "Não aceita receber mensagens<br>";
          }
        }
      }, {
        data: null,
        render: function render(data, type, row) {
          var icon = "";
          if (data.status_facilitador == 1) {
            // Ícone para status ativo
            icon = "\n                <svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                    <circle cx=\"12\" cy=\"12\" r=\"10\" fill=\"#28a745\"/>\n                    <path d=\"M16 8L10 14L7 11\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n                </svg>\n                <span style=\"color: #28a745; font-weight: bold;\">Ativo</span>\n            ";

            // Se efetivo == 1, apenas mostra "SIM" e não exibe o switch
            // if (data.efetivo == 1) {
            return "<span>".concat(data.nome_facilitador, " ").concat(data.sobrenome_facilitador, " ").concat(icon, "</span>");
            // }

            // Caso contrário, exibe o switch
            // let checked = data.efetivo == 1 ? "checked" : "";
            // let textStatus = data.efetivo == 1 ? "SIM" : "NÃO";
            //
            // let switchInput = `
            //   <div class="switch-container">
            //       Efetivo?
            //       <label class="switch">
            //           <input type="checkbox" ${checked} data-id="${data.id_encrypt}">
            //           <span class="slider round"></span>
            //       </label>
            //       <span class="switch-label">${textStatus}</span>
            //   </div>
            // `;

            // return `<span>${data.nome_facilitador} ${data.sobrenome_facilitador} ${icon}</span>`;
          } else {
            // Ícone para status pendente
            icon = "\n                <svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                    <circle cx=\"12\" cy=\"12\" r=\"10\" fill=\"#ffc107\"/>\n                    <path d=\"M12 8V12M12 16H12.01\" stroke=\"black\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n                </svg>\n                <span style=\"color: #ffc107; font-weight: bold;\">Pendente</span>\n            ";
            return "<span>".concat(data.nome_facilitador, " ").concat(data.sobrenome_facilitador, " ").concat(icon, "</span>");
          }
        }
      }, {
        data: null,
        render: function render(data, type, row) {
          var efetivo = parseInt(data.efetivo); // garante que seja número

          return "\n      <select class=\"form-select status-contato\" data-id=\"".concat(row.id_novo_convertido, "\" data-efetivo=\"").concat(efetivo, "\"> \n        <option value=\"1\" ").concat(efetivo === 1 ? "selected" : "", ">Efetivo</option>\n        <option value=\"2\" ").concat(efetivo === 2 ? "selected" : "", ">N\xE3o Efetivo</option>\n        <option value=\"0\" ").concat(efetivo === 0 || isNaN(efetivo) ? "selected" : "", ">Pendente</option>\n      </select>\n    ");
        }
      }, {
        data: "data_criado"
      }, {
        data: null,
        // class: "text-left table-name",
        render: function render(data, type, row) {
          var callToAction = '<div class="d-flex">';
          if (data.status_facilitador == 0) {
            callToAction += " <div class=\"members-item-action\">\n              <a href=\"#\" data-modal=\"open\" data-modal-name=\"facilitator\" data-id_facilitador=\"".concat(data.id_facilitador, "\" data-id_novo_convertido=\"").concat(data.id_encrypt, "\" data-id_usuario_facilitador=\"").concat(data.id_usuario_facilitador, "\">\n              Facilitador\n              </a>\n          </div>\n          <div class=\"members-item-action\">\n              <a href=\"").concat(baseURL, "cadastro/novos-convertidos/contato-realizado\" class=\"ativar_contato\" data-id_facilitador=\"").concat(data.id_facilitador, "\" data-id_novo_convertido=\"").concat(data.id_encrypt, "\" data-id_usuario_facilitador=\"").concat(data.id_usuario_facilitador, "\">\n              Confirmar\n              </a>\n          </div>\n          ");
          }
          // <div class="members-item-action">
          //     <a href="${baseURL}#">
          //       Transformar novo membro
          //       <img src="/theme/src/img/icon/member-item-user.svg" alt="" />
          //     </a>
          //   </div>
          //    <div class="members-item-action">
          //    <a href="#" data-modal="open" data-modal-name="details">
          //      Ver detalhes
          //      <img src="/theme/src/img/icon/member-item-details.svg" alt="" />
          //    </a>
          //  </div>
          return callToAction + "\n            <div class=\"members-item-action\">\n              <div class=\"members-item-action\">\n                <a href=\"".concat(baseURL, "cadastro/novos-convertidos/editar/").concat(data.id_encrypt, "\">\n                Editar\n                </a>\n              </div>\n            </div>\n            </div>");
        }
      }],
      columnDefs: [{
        targets: -1,
        // Última coluna (Ações)
        orderable: false,
        searchable: false,
        width: "10%"
      }, {
        targets: [3, 4, 5, 6, 7, 8, 9, 10, 11],
        // Colunas que não devem ser ordenáveis
        orderable: false
      }, {
        targets: 3,
        // Coluna de endereço
        width: "200px"
      }],
      initComplete: function initComplete() {
        (0, _userDetails.userDetails)({
          endpoint: "".concat(baseURL, "ajax/membros")
        });
        $('input[type="search"]').attr("placeholder", "Ex: João");
        $(".home .box-top .right").append($(".dataTables_length"));
        $(".home .box-top .right").append($(".dataTables_filter"));
        $("div.dt-search").append('<img src="/theme/src/img/icon/search.svg" alt="ícone de uma lupa">');

        // btnModalNewConvert
        var btnModalNewConvert = $('[data-modal="open"][data-modal-name="details"]');
        var modalNewConvert = $('[data-modal="details"]');
        btnModalNewConvert.on("click", function () {
          modalNewConvert.addClass("active");
        });
        $('.dt-buttons').appendTo('.box-top .left');
      },
      drawCallback: function drawCallback() {
        setTimeout(function () {
          loaderPage.removeClass("loading");
          loaderPage.removeClass("active");
        }, 500);

        // btnModalFacilitator
        var btnModalFacilitator = $('[data-modal="open"][data-modal-name="facilitator"]');
        var modalFacilitator = $('[data-modal="facilitator"]');
        btnModalFacilitator.on("click", function () {
          // Use function() para capturar "this"
          modalFacilitator.addClass("active");

          // Captura o data-id_facilitador do botão que foi clicado
          var idFacilitador = $(this).data("id_facilitador");
          var idNovoConvertido = $(this).data("id_novo_convertido");
          var idUsuarioFacilitador = $(this).data("id_usuario_facilitador");

          // Atualiza o select apenas se o ID for válido
          if (idFacilitador !== undefined && idFacilitador !== null) {
            // Remove a seleção anterior
            $("#id_facilitador option:selected").removeAttr("selected");

            // Seleciona a nova opção
            $("#id_facilitador").val(idFacilitador).prop("selected", true).trigger("change");
            $('[name="id_novo_convertido"]').val(idNovoConvertido);
            $('[name="id_usuario_facilitador"]').val(idUsuarioFacilitador);
          }
        });
        $(".ativar_contato").on("click", function (e) {
          e.preventDefault();
          var hrefPost = $(this).attr("href"),
            id = $(this).data("id_usuario_facilitador");
          $.ajax({
            url: hrefPost,
            data: {
              id: id
            },
            dataType: "json",
            type: "post",
            beforeSend: function beforeSend(x, o) {
              console.log("Enviando Dados...");
            },
            success: function success(response) {
              location.reload();
            },
            complete: function complete() {},
            error: function error(XMLHttpRequest, textStatus, errorThrown) {
              console.log(errorThrown);
            }
          });
        });
        atualizarStatusEfetivo();
      }
    });
  }
}

},{"../../global/userDetails.js":9}],17:[function(require,module,exports){
"use strict";

var _loaderPageRemoveOnLoadPage = require("./global/loaderPageRemoveOnLoadPage.js");
var _loaderPageChangeMessage = require("./global/loaderPageChangeMessage.js");
var _linkDropdown = require("./global/linkDropdown.js");
var _inputIcon = _interopRequireDefault(require("./components/inputIcon.js"));
var _modal = _interopRequireDefault(require("./components/modal.js"));
var _sidebar = _interopRequireDefault(require("./components/sidebar.js"));
var _knowledgeBaseItem = _interopRequireDefault(require("./components/knowledgeBaseItem.js"));
var _membersTable = require("./pages/members/membersTable.js");
var _eventsTable = require("./pages/events/eventsTable.js");
var _messageTable = require("./pages/message/messageTable.js");
var _newConvertTable = require("./pages/newConvert/newConvertTable.js");
var _congregatedTable = require("./pages/congregated/congregatedTable.js");
var _coursesClassTabnav = require("./pages/courses/coursesClassTabnav.js");
var _coursesClassSummaryOptions = require("./pages/courses/coursesClassSummaryOptions.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
(0, _linkDropdown.linkDropdown)();
(0, _modal["default"])();
(0, _inputIcon["default"])();
(0, _sidebar["default"])();
(0, _knowledgeBaseItem["default"])();

// loaderPageChangeMessage();
(0, _loaderPageRemoveOnLoadPage.loaderPageRemoveOnLoadPage)();
(0, _membersTable.membersTable)();
(0, _messageTable.messageTable)();
(0, _newConvertTable.newConvertTable)();
(0, _congregatedTable.congregatedTable)();
(0, _coursesClassTabnav.coursesClassTabnav)();
(0, _coursesClassSummaryOptions.coursesClassSummaryOptions)();
(0, _eventsTable.eventsTable)();
var app = {
  init: function init() {
    this.autoCompletarCep();
  },
  autoCompletarCep: function autoCompletarCep() {
    function limpa_formulário_cep() {
      // Limpa valores do formulário de cep.
      $("#logradouro").val("");
      $("#bairro").val("");
      $("#cidade").val("");
      $("#uf").val("");
      $("#ibge").val("");
    }

    //Quando o campo cep perde o foco.
    $("#cep").blur(function () {
      //Nova variável "cep" somente com dígitos.
      var cep = $(this).val().replace(/\D/g, "");

      //Verifica se campo cep possui valor informado.
      if (cep != "") {
        //Expressão regular para validar o CEP.
        var validacep = /^[0-9]{8}$/;

        //Valida o formato do CEP.
        if (validacep.test(cep)) {
          //Preenche os campos com "..." enquanto consulta webservice.
          $("#logradouro").val("...");
          $("#bairro").val("...");
          $("#cidade").val("...");
          $("#uf").val("...");
          $("#ibge").val("...");

          //Consulta o webservice viacep.com.br/
          $.getJSON("https://viacep.com.br/ws/" + cep + "/json/?callback=?", function (dados) {
            if (!("erro" in dados)) {
              //Atualiza os campos com os valores da consulta.
              $("#logradouro").val(dados.logradouro);
              $("#bairro").val(dados.bairro);
              $("#cidade").val(dados.localidade);
              $("#uf").val(dados.uf);
              $("#ibge").val(dados.ibge);
            } //end if.
            else {
              //CEP pesquisado não foi encontrado.
              limpa_formulário_cep();
              alert("CEP não encontrado.");
            }
          });
        } //end if.
        else {
          //cep é inválido.
          limpa_formulário_cep();
          alert("Formato de CEP inválido.");
        }
      } //end if.
      else {
        //cep sem valor, limpa formulário.
        limpa_formulário_cep();
      }
    });
  }
};
$(document).ready(function () {
  app.init();
});

},{"./components/inputIcon.js":1,"./components/knowledgeBaseItem.js":2,"./components/modal.js":3,"./components/sidebar.js":4,"./global/linkDropdown.js":5,"./global/loaderPageChangeMessage.js":6,"./global/loaderPageRemoveOnLoadPage.js":7,"./pages/congregated/congregatedTable.js":10,"./pages/courses/coursesClassSummaryOptions.js":11,"./pages/courses/coursesClassTabnav.js":12,"./pages/events/eventsTable.js":13,"./pages/members/membersTable.js":14,"./pages/message/messageTable.js":15,"./pages/newConvert/newConvertTable.js":16}]},{},[17]);
